import { AtomicBlockUtils, EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import React, { Component } from 'react';
import { FontIcon } from 'react-md';
import TextEditor from './TextEditor';
//Add Image Button

export default class AddImageButton extends Component {
  
  
    constructor(props)
    {
        super(props);
        this.onClick =    this.onClick.bind(this);
        this.inputID  = Math.random().toString();

    }
    insertImage(editorState, url, extraData) {
      var urlType = 'IMAGE';
      var contentState = editorState.getCurrentContent();
      var contentStateWithEntity = contentState.createEntity(urlType, 'IMMUTABLE', { src: url, alignment: 'center' });
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      var newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
      // The below 3 lines are added to remove the empty p tags before and after image
      let str = TextEditor.getHTMLStringFromEditorState(newEditorState)
      let modifiedHtml = str.replace("<p><br></p>", "");
      newEditorState = TextEditor.createValueFromString(modifiedHtml);
      return EditorState.moveFocusToEnd(newEditorState);
      // return EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
    };
  
    imageToBase64(src) {
   
      return new Promise(
        function (resolve, reject) {
            let reader = new FileReader();
            reader.addEventListener(
          'load',
          function assignImageSrc(evt) {
          
            let imgSrc = evt.target.result;
            this.removeEventListener('load', assignImageSrc);
            resolve(imgSrc);
          },
          true
        );
        reader.readAsDataURL(src);
        });
    }
  
    onClick = (event) => {
        console.log('name',this.props.name);
     let files = event.target.files;
     const { setEditorState, getEditorState } = this.props
      if (files[0].type.includes('image')) {
       let editorState  =  getEditorState();
        this.imageToBase64(files[0]).then((result) => {
          console.debug("result>>>", result)
        let newEditorState = this.insertImage(editorState,result);
        setEditorState(newEditorState);
        document.getElementById(this.inputID).value = null;
       });
       
      }
  
    }
  
    render() {
      return (
        <div className='draftJsToolbar__buttonWrapper__1Dmqh' style={{background:'#fbfbfb'}}>
            <label htmlFor={this.inputID} className='draftJsToolbar__button__qi1gf'>
              <FontIcon style={{fontSize:24}} >add_photo_alternate</FontIcon>
          </label>
          <input onChange={this.onClick.bind(this)} id={this.inputID} type='file' accept="image/*" name="images" style={{display:'none'}} />
        </div>
      );
    }
  }
  